import API from 'shared/constants/api';
import { createVocabularyForTypes } from 'shared/helpers/api';
import { getChildTransportsBySlug } from 'shared/helpers/transportTypes';
import transportTypes from 'shared/constants/json/transportTypes.json';

/* General constants */

export const MAX_UPLOADED_PHOTOS_COUNT = 20;
export const OTHER_ITEM = {
  id: null,
  title: 'Другая',
};

export const FORM_STEPS = {
  MAIN: 'MAIN',
  PUBLISH_AND_PAY: 'PUBLISH_AND_PAY',
  QUALITY: 'QUALITY',
};

export const FORM_STEPS_TITLE = {
  MAIN: 'Основная информация',
  PUBLISH_AND_PAY: 'Публикация и оплата',
  QUALITY: 'Качество объявления',
};

/* Vocabulary */

// Types
const motoTypes = ['moto', ...getChildTransportsBySlug('moto').map(type => type.slug)];
const busTypes = ['avtobus', ...getChildTransportsBySlug('avtobus').map(type => type.slug)];
const technicsTypes = [
  'spetstehnika',
  ...getChildTransportsBySlug('spetstehnika').map(type => type.slug),
];
const waterTypes = [
  'vodnyi-transport',
  ...getChildTransportsBySlug('vodnyi-transport').map(type => type.slug),
];
const trailerTypes = ['pritsepy', ...getChildTransportsBySlug('pritsepy').map(type => type.slug)];
const truckTypes = ['gruzovye', ...getChildTransportsBySlug('gruzovye').map(type => type.slug)];

// Classifiers
const {
  subtypes: categories,
  services,
  makes,
  drives,
  options,
  engines,
  gearboxes,
  locations,
  colors,
  colorFeatures,
  currencies,
  tacts,
  engineOrders,
  ecotypes,
  unloadings,
  suspensions,
  brakes,
  cabins,
  cabinSuspensions,
  chassisSuspensions,
  seaworthinessClasses,
} = API.VOCABULARY;

const sharedPart = {
  services,
  makes,
  drives,
  options,
  engines,
  gearboxes,
  locations,
  colors,
  colorFeatures,
  currencies,
};

export const VOCABULARY = {
  // Avto
  avto: {
    ...sharedPart,
  },
  // Moto
  ...createVocabularyForTypes(motoTypes, {
    ...sharedPart,
    categories,
    tacts,
    engineOrders,
  }),
  // Trucks
  ...createVocabularyForTypes(truckTypes, {
    ...sharedPart,
    categories,
    ecotypes,
    unloadings,
    cabins,
    cabinSuspensions,
    chassisSuspensions,
  }),
  // Buses
  ...createVocabularyForTypes(busTypes, {
    ...sharedPart,
    categories,
    ecotypes,
  }),
  // Technics
  ...createVocabularyForTypes(technicsTypes, {
    ...sharedPart,
    categories,
    ecotypes,
    unloadings,
  }),
  // Water
  ...createVocabularyForTypes(waterTypes, {
    ...sharedPart,
    categories,
    ecotypes,
    unloadings,
    seaworthinessClasses,
  }),
  // Trailer
  ...createVocabularyForTypes(trailerTypes, {
    ...sharedPart,
    categories,
    unloadings,
    suspensions,
    brakes,
  }),
};

export const submenuItems = [
  ...transportTypes
    .filter(type => type.isInAdvertFormNavigation)
    .map(item => ({ route: `/add/${item.slug}/`, title: item.title })),
  { route: '/add/zapchasti/', title: 'Запчасти' },
];



// WEBPACK FOOTER //
// ./src/shared/constants/advertForm.js